import React, { useState, useEffect } from 'react';
// import { Youtube, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import {FaYoutube,FaFacebook,FaTwitter, FaInstagram} from 'react-icons/fa'
import {BiLogoLinkedin,BiLogoFacebook} from 'react-icons/bi'

const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Clean up
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Footer links data
  const footerLinks = {
    company: {
      title: 'Hellocer',
      links: [
        { name: 'About', url: '/about-us' },
        { name: 'Privacy Policy', url: '/privacy-policy' },
             { name: 'Terms of Services', url: '/terms-of-services' },
        { name: 'Careers', url: '/careers' }
      ]
    },
    product: {
      title: 'PRODUCT',
      links: [
        { name: 'Pricing', url: '/project-submission' },
        { name: 'Browse', url: '/services' },
          { name: 'Refund Policy', url: '/refund-policy' },
      ]
    },
    solutions: {
      title: 'SOLUTIONS',
      links: [
        { name: 'UI/UX Design', url: '/category/uiux-design' },
        { name: 'Web Design', url: '/category/web-design' },
        { name: 'Wordpress', url: '/category/wordpress' },
        { name: 'Software Development', url: '/category/software-development' }
      ]
    },
    resources: {
      title: 'RESOURCES',
      links: [
        { name: 'Help Center', url: '/help-center' },
        { name: 'Contact us', url: '/contact-us' },
        { name: 'Disclaimer', url: '/disclaimer' },
        { name: 'Tutorials', url: '/tutorials' }
      ]
    }
  };

  // Social media icons
  const socialIcons = [
    { icon: <FaYoutube size={20} />, url: 'https://youtube.com' },
    { icon: <BiLogoFacebook size={20} />, url: 'https://facebook.com' },
    { icon: <FaTwitter size={20} />, url: 'https://twitter.com' },
    { icon: <FaInstagram size={20} />, url: 'https://instagram.com' },
    { icon: <BiLogoLinkedin size={20} />, url: 'https://linkedin.com' }
  ];

  const DesktopFooter = () => (
    <footer className="py-12 px-20">
      <div className="container mx-auto">
        {/* Main Footer */}
        <div className="grid grid-cols-4 gap-x-6 gap-y-8 mb-12">
          <div>
            {/* <h3 className="text-xl font-medium text-blue-800 mb-6">{footerLinks.company.title}</h3> */}
            <h3 className="text-xl font-medium text-[#174568]">
            Hello<span className="text-[#7295B8]">cer</span>
          </h3>
            <ul className="space-y-4 mt-4">
              {footerLinks.company.links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-gray-600 hover:text-blue-800">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 mb-6">{footerLinks.product.title}</h3>
            <ul className="space-y-4">
              {footerLinks.product.links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-gray-600 hover:text-blue-800">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 mb-6">{footerLinks.solutions.title}</h3>
            <ul className="space-y-4">
              {footerLinks.solutions.links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-gray-600 hover:text-blue-800">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-gray-800 mb-6">{footerLinks.resources.title}</h3>
            <ul className="space-y-4">
              {footerLinks.resources.links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-gray-600 hover:text-blue-800">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 mb-8"></div>

        {/* Copyright & Social */}
        <div className="flex justify-between items-center">
          <div className="text-gray-500 text-sm">
            &copy; 2024 Hellocer Technologies. All rights reserved.
          </div>

          <div className="flex items-center space-x-6">
            <a href="/terms-of-services" className="text-gray-600 hover:text-blue-800">
              Terms
            </a>
            <a href="/privacy-policy" className="text-gray-600 hover:text-blue-800">
              Privacy
            </a>
            <a href="/contact-us" className="text-gray-600 hover:text-blue-800">
              Contact
            </a>

            <div className="flex space-x-4 ml-4">
              {socialIcons.map((social, index) => (
                <a 
                  key={index}
                  href={social.url}
                  className="text-gray-500 hover:text-blue-800"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );

  const MobileFooter = () => (
    <footer className="py-8 px-4">
      <div className="container mx-auto">
        {/* Main Footer */}
        <div className="grid grid-cols-2 gap-x-3 gap-y-6 mb-8">
          <div>
            {/* <h3 className="text-base font-medium text-blue-800 mb-4">{footerLinks.company.title}</h3> */}
            <h3 className="text-xl font-medium text-[#174568]">
            Hello<span className="text-[#7295B8]">cer</span>
          </h3>
            <ul className="space-y-3 mt-4">
              {footerLinks.company.links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-sm text-gray-600 hover:text-blue-800">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-gray-800 mb-4">{footerLinks.product.title}</h3>
            <ul className="space-y-3">
              {footerLinks.product.links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-sm text-gray-600 hover:text-blue-800">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-gray-800 mb-4">{footerLinks.solutions.title}</h3>
            <ul className="space-y-3">
              {footerLinks.solutions.links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-sm text-gray-600 hover:text-blue-800">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-gray-800 mb-4">{footerLinks.resources.title}</h3>
            <ul className="space-y-3">
              {footerLinks.resources.links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-sm text-gray-600 hover:text-blue-800">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 mb-6"></div>

        {/* Copyright */}
        <div className="text-gray-500 text-xs mb-4">
          &copy;2025 Hellocer Technology. All rights reserved.
        </div>

        {/* Terms and Social */}
        <div className="flex flex-wrap items-center">
          <div className="flex space-x-4 text-sm mb-4 w-full">
            <a href="/terms-of-services" className="text-gray-600 hover:text-blue-800">
              Terms
            </a>
            <a href="/privacy-policy" className="text-gray-600 hover:text-blue-800">
              Privacy
            </a>
            <a href="/contact-us" className="text-gray-600 hover:text-blue-800">
              Contact
            </a>
          </div>

          <div className="flex space-x-4">
            {socialIcons.map((social, index) => (
              <a 
                key={index}
                href={social.url}
                className="text-gray-500 hover:text-blue-800"
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );

  return isMobile ? <MobileFooter /> : <DesktopFooter />;
};

export default Footer;